import CorporateCardRequestsContainer from "../../modules/CorporateCardRequests/components/CardRequests.Container/CardRequests.Container";

const CorporateRequestsPage = () => {
  return <CorporateCardRequestsContainer cardFormat={"corporate"} />;
};

export default CorporateRequestsPage;
